<template>
  <div class="hear_BD">
    <div style="position:relative;" class="arrowsBox">
         <div style="position: absolute;
    top: -54px;
    left: 226px;">当前正在申请{{bao_type}}</div>
      <div class="arrowsItem" v-for="(item, index) in list" :key="index">
           
        <!-- arrows_active  选中背景 arrows_done  已完成背景 arrows_todo 未开始-->
        <div class="arrows-up arrows" :class="{
          arrows_active: item.prop == num,
          arrows_done: item.prop < num,
          arrows_todo: item.prop > num,
        }">
         <div @click="tiaoz(item)" class="icons">
            <img class="iconimg" v-if="item.prop == num" :src="item.img2" alt="1" srcset="">
            <img class="iconimg" v-if="item.prop < num" :src="item.img3" alt="2" srcset="">
            <img class="iconimg" v-if="item.prop > num" :src="item.img1" alt="3" srcset="">
            <span class="icontext1" v-if="item.prop == num"> {{ item.label }}</span>
            <span class="icontext2" v-if="item.prop < num"> {{ item.label }}</span>
            <span class="icontext3" v-if="item.prop > num"> {{ item.label }}</span> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BDhear",
  props: {
    //props列表
    num: Number,
  },
  data() {
    return {
      IconList: [
        {
          url: "../../assets/BidSecurity/icon.png",
          status: "0",
          name: "选择标段",
        },
        {
          url: "../../assets/BidSecurity/icon1.png",
          status: "1",
          name: "选择出函机构",
        },
        {
          url: "../../assets/BidSecurity/icon2.png",
          status: "0",
          name: "提交资料",
        },
        {
          url: "../../assets/BidSecurity/icon3.png",
          status: "0",
          name: sessionStorage.getItem("bhlein"),
        },
        {
          url: "../../assets/BidSecurity/icon4.png",
          status: "0",
          name: "电子保函协议",
        },
        {
          url: "../../assets/BidSecurity/icon5.png",
          status: "0",
          name: "电子签章",
        },
        {
          url: "../../assets/BidSecurity/icon6.png",
          status: "0",
          name: "支付",
        },
        {
          url: "../../assets/BidSecurity/icon7.png",
          status: "0",
          name: "发放保函",
        },  {
          url: "../../assets/BidSecurity/9-3.png",
          status: "0",
          name: "快递信息",
        },
      ],
      list: [
        {
          label: "选择标段",
          prop: 1,
          img1: require("../../assets/BidSecurity/1-2.png"),
          img2: require("../../assets/BidSecurity/1-2.png"),
          img3: require("../../assets/BidSecurity/1-3.png"),
          status: "active",
          url:"/SelectLot",
        },
        {
          label: "选择出函机构",
          prop: 2,
          img1: require("../../assets/BidSecurity/2-1.png"),
          img2: require("../../assets/BidSecurity/2-2.png"),
          img3: require("../../assets/BidSecurity/2-3.png"),
          status: "todo",
           url:"/Institution",
        },
        {
          label: "提交资料",
          prop: 3,
          img1: require("../../assets/BidSecurity/3-1.png"),
          img2: require("../../assets/BidSecurity/3-2.png"),
          img3: require("../../assets/BidSecurity/3-3.png"),
          status: "todo",
           url:"/Submittals",
        },
        {
          label: sessionStorage.getItem("bhlein"),
          prop: 4,
          img1: require("../../assets/BidSecurity/4-1.png"),
          img2: require("../../assets/BidSecurity/4-2.png"),
          img3: require("../../assets/BidSecurity/4-3.png"),
          status: "todo",
           url:"/BidFroms",
        },
        {
          label: "个人反担保",
          prop: 5,
          img1: require("../../assets/BidSecurity/5-1.png"),
          img2: require("../../assets/BidSecurity/5-2.png"),
          img3: require("../../assets/BidSecurity/5-3.png"),
          status: "todo",
           url:"/Fgreement",
        },
        {
          label: "电子签章",
          prop: 6,
          img1: require("../../assets/BidSecurity/6-1.png"),
          img2: require("../../assets/BidSecurity/6-2.png"),
          img3: require("../../assets/BidSecurity/6-3.png"),
          status: "todo",
           url:"/Agreement",
        },
        {
          label: "支付",
          prop: 7,
          img1: require("../../assets/BidSecurity/7-1.png"),
          img2: require("../../assets/BidSecurity/7-2.png"),
          img3: require("../../assets/BidSecurity/7-3.png"),
          status: "todo",
           url:"/Bidpayments",
        },
        {
          label: "发放保函",
          prop: 8,
          img1: require("../../assets/BidSecurity/8-1.png"),
          img2: require("../../assets/BidSecurity/8-2.png"),
          img3: require("../../assets/BidSecurity/8-3.png"),
          status: "todo",
           url:"/Public",
        },
            {
          label: "快递信息",
          prop: 9,
          img1: require("../../assets/BidSecurity/9-3.png"),
          img2: require("../../assets/BidSecurity/9-1.png"),
          img3: require("../../assets/BidSecurity/9-2.png"),
          status: "todo",
          url:"/Express",
        },
      ],
         listly: [
        {
          label: "选择标段",
          prop: 1,
          img1: require("../../assets/BidSecurity/1-2.png"),
          img2: require("../../assets/BidSecurity/1-2.png"),
          img3: require("../../assets/BidSecurity/1-3.png"),
          status: "active",
           url:"/SelectLot",
        },
        {
          label: "选择出函机构",
          prop: 2,
          img1: require("../../assets/BidSecurity/2-1.png"),
          img2: require("../../assets/BidSecurity/2-2.png"),
          img3: require("../../assets/BidSecurity/2-3.png"),
          status: "todo",
            url:"/Institution",
        },
        {
          label: "提交资料",
          prop: 3,
          img1: require("../../assets/BidSecurity/3-1.png"),
          img2: require("../../assets/BidSecurity/3-2.png"),
          img3: require("../../assets/BidSecurity/3-3.png"),
          status: "todo",
            url:"/Submittals",
        },
        {
          label: sessionStorage.getItem("bhlein"),
          prop: 4,
          img1: require("../../assets/BidSecurity/4-1.png"),
          img2: require("../../assets/BidSecurity/4-2.png"),
          img3: require("../../assets/BidSecurity/4-3.png"),
          status: "todo",
            url:"/BidFroms",
        },
        {
          label: "电子签章",
          prop: 6,
          img1: require("../../assets/BidSecurity/6-1.png"),
          img2: require("../../assets/BidSecurity/6-2.png"),
          img3: require("../../assets/BidSecurity/6-3.png"),
          status: "todo",
          url:"/Agreement",
        },
        {
          label: "支付",
          prop: 7,
          img1: require("../../assets/BidSecurity/7-1.png"),
          img2: require("../../assets/BidSecurity/7-2.png"),
          img3: require("../../assets/BidSecurity/7-3.png"),
          status: "todo",
            url:"/Bidpayments",
        },
        {
          label: "发放保函",
          prop: 8,
          img1: require("../../assets/BidSecurity/8-1.png"),
          img2: require("../../assets/BidSecurity/8-2.png"),
          img3: require("../../assets/BidSecurity/8-3.png"),
          status: "todo",
             url:"/Public",
        },
            {
          label: "快递信息",
          prop: 9,
          img1: require("../../assets/BidSecurity/9-3.png"),
          img2: require("../../assets/BidSecurity/9-1.png"),
          img3: require("../../assets/BidSecurity/9-2.png"),
          status: "todo",
            url:"/Express",
        },
      ],
      bao_type:sessionStorage.getItem("bhlein"),
    };
  },
  created(e) {
    if(sessionStorage.getItem("bhlein")=="投标保函"){
this.list=this.listly
    }
    console.log(e); //5
  },
  methods: {
    tiaoz(i){
      console.log(i.prop,this.num)
      if(i.prop < this.num){
       this.$confirm('是否跳转：'+i.label+"", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        this.$router.push(i.url);
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });          
        });
      }else{
        console.log("不可跳转")
      }

    },
    next() {
      for (let item of this.list) {
        if (item.status === "active") {
          item.status = "done";
        }

        if (item.status === "todo") {
          item.status = "active";
          if (this.list[this.list.length - 1].status === "active") {
            this.unFinish = false;
          }
          break;
        }
      }
    },
  },
};
</script>

<style scoped>
.icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.icontext1{
font-size: 16px;
font-family: Microsoft YaHei-Regular, Microsoft YaHei;
font-weight: 400;
color: #FFFFFF;
}
.icontext2{
font-size: 16px;
font-family: Microsoft YaHei-Regular, Microsoft YaHei;
font-weight: 400;
color: #1795FF;
}
.icontext3{
font-size: 16px;
font-family: Microsoft YaHei-Regular, Microsoft YaHei;
font-weight: 400;
color: #333333;
}
.iconimg {
  width: 30px;
  height: 30px;
  margin-bottom: 10px;
}
.hear_BD {
  /* width: 1920px; */
  height: 80px;
  background-color: #f5f6fa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

.arrowsBox {
  display: flex;
  justify-content: center;
  width: 99%;
  font-weight: bold;
}

.arrowsItem {
  flex: 1;
  /* position: relative; */
  height: 80px;
  /* width: 188.78px; */
}

/* .arrows-up {
  transform: skewX(10deg);
}

.arrows-down {
  transform: skewX(-10deg);
} */

/* .arrows {
  height: 50%;

  background: gray;
} */

.arrows-label {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
}

.arrows_done {
  background: #d5e8fa;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.arrows_active {
  /* background-url: #1795FF; */
  background: url(../../assets/BidSecurity/xin1.png);
      background-repeat: round;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.arrows_todo {
  background: #fff;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.arrows_label_done {
  color: #009fe9;
}

.arrows_label_active {
  color: #fff;
}

.arrows_label_todo {
  color: #929393;
}

.btn {
  background: #009fe9;
  color: #fff;
  border: none;
  padding: 6px;
  width: 100px;
  border-radius: 4px;
  margin: auto;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/view/BidSecurity/BDhear.vue